<script>
    import {push} from "svelte-spa-router";
</script>

<div class="home">
    <div class="float-right">
        <div class="icon-holder">
            <i class="force-blue-brand ui huge icon bitcoin"></i>
        </div>
        <div class="fund-cta">
            <h2 style="margin-bottom: 0px;">Funding by the People for the People</h2>
            <h3>
            Host your fundraiser on a bias free platform resistant to big tech. 
            At Plithos Fund your fundraiser is none of our business until it breaks the law, whether you are raising funds for a medical procedure or posting bail, we've got your back.
            </h3>
            <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center !important;" class="but">
                <button 
                    class="bob fc b br2 ph3 pv2 mb2 dib white bg-brand-green"
                >
                Start a Fundraiser
                </button>
                <h4 style="margin-left: 0.8rem; margin-bottom: 0px;" >currently invite only</h4>
            </div>
        </div>
    </div>
    <div class="split"></div>
    <div class="float-right">
        <div class="icon-holder">
            <i class="force-blue-brand ui huge icon dollar sign"></i>
        </div>
        <div class="donate-cta">
            <h2 style="margin-bottom: 0px;">Donate to Those who Need it Most</h2>
            <h3>
            While new Plithos Fund campaigns are invite only currently, donating to campaigns is publicly availible. The silenced come to this platform to seek aid, you can provide it.
            </h3>
            <div class="but">
                <button 
                    on:click={() => push('/search')}
                    class="fc b dim br2 ph3 pv2 mb2 dib white bg-brand-green"
                >
                Donate to a Fundraiser
                </button>
            </div>
        </div>
    </div>
    <div class="split"></div>
    <h2>New to Using Bitcoin?</h2>
    <h3>We highly suggest buying Bitcoin with 
        <span><a target="_blank" href="https://www.kraken.com">Kraken</a></span> or 
        <span><a target="_blank" href="https://www.coinbase.com/">Coinbase</a></span>.
        You can learn about Cryptocurrency on <span><a href="https://www.kraken.com/en-us/learn">Kraken's Learn Page</a>.</span>
        However if you already have Bitcoin to donate to your fundraiser of choice you can donate now.
    </h3>
    <div class="but">
        <button 
            on:click={() => push('/search')}
            class="fc b dim br2 ph3 pv2 mb2 dib white bg-brand-green"
        >
        Donate to a Fundraiser
        </button>
    </div>
    <div class="split"></div>
    <h2>Why don't we support credit card donations?</h2>
    <h3>The modern banking system is controlled by individuals and groups who seek to suppress others. To use these systems is to support that suppression.
    Cryptocurrency on the other hand does not directly support groups who want to supress others. Every business who removes there support for the modern banking system brings us one
     step closer to freedom.</h3>
</div>

<style>
    .bob, bob:active {
        text-decoration: line-through;
        background-color: #ccc;
    }
    h3 {
        color: #4E4B5C;
        font-weight: semi-bold;
    }
    .split {
        height: 2px;
        width: 100%;
        margin-top: 2rem;
        margin-bottom: 2rem;
        background-color: #CCC;
    }
    .icon-holder {
        width: 4rem;
        height: 4rem;
        display: none;
        align-items: center;
        justify-content: center;
    }
    .force-blue-brand {
        color: #3891FF;
        display: none;
    }
    .float-right {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .fc {
        width: fit-content;
        margin-top: 1.6rem;
    }

    .but {
        display: flex;
        justify-content: center;
    }

    .fund-cta {
        margin-left: 0px;
        display: flex;
        flex-direction: column;
    }
    .donate-cta {
        margin-left: 0px;
        display: flex;
        flex-direction: column;
    }

    .start {
        align-self: center;
    }

    .home {
        width: 100%;
    }

    @media only screen and (min-width: 768px) {
        .home {
            width: 90%;
            max-width: 80rem;
            min-width: 44rem;
        }
        .force-blue-brand {
            display: initial;
        }
        .but {
            display: initial;
        }
        .icon-holder {
            display: flex;
        }
        .fund-cta {
            margin-left: 1rem;
        }
        .donate-cta {
            margin-left: 1rem;
        }
    }
</style>
